export default __webpack_public_path__ + "static/media/pattern-002-4.ca1c123f.jpg";